import { createAction, props } from '@ngrx/store';
import { AppUserState } from '../_models/app.models';

export const setUserState = createAction('[User] Set User State', props<AppUserState>()) ;
export const reset = createAction('[User] Reset');
